exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.customer-table[data-v-d02cdf76] {\n    width: 700px;\n}\n.customer-table td[data-v-d02cdf76] {\n    width: 50%;\n}\n", ""]);

// exports
